export const RoleName = {
  Admin: 'admin',
  RegionLead: 'regionlead',
  GroupLead: 'grouplead',
  AwardLead: 'awardlead',
  AwardNominationReviewer: 'awardnominationreviewer',
  CountryLead: 'countrylead',
  CountryNominationReviewer: 'countrynominationreviewer',
  Judge: 'judge',
  NominationJudge: 'nominationjudge',
  Partner: 'partner',
  NominationReviewer: 'nominationreviewer',
} as const;

export type RoleName = typeof RoleName[keyof typeof RoleName];

export interface UserInfo {
  userId: number;
  firstName: string;
  lastName: string;
  email: string;
  roles: RoleName[];
  hasPcAccount: boolean;
  isWinner?: boolean;
}
